import { NavigateFunction } from "react-router-dom";
import { AuthApi } from "../shared/api/axios-client";
import { createApiService } from "../shared/apiConfig";
import { Parker } from "./ApiTypes";

interface LoginAndRedirectParams {
    emailAddress: string;
    password: string;
    parker: Parker;
    setAuthToken: (token: { accessToken: string }) => void;
    setAuth: (auth: { isLoggedIn: boolean; account: any }) => void;
    redirect: string | undefined;
    setRedirect: (redirect: string | undefined) => void;
    nav: NavigateFunction;
}

/**
 * Shared logic for logging in a user and redirecting them after successful authentication
 * Used by SignUpPage and ResetPasswordPage
 */
export function loginAndRedirect({
    emailAddress,
    password,
    parker,
    setAuthToken,
    setAuth,
    redirect,
    setRedirect,
    nav
}: LoginAndRedirectParams): Promise<void> {
    const authApi = createApiService(AuthApi);
    
    return authApi.login({
        serverServicesIntegrationsAccountLoginRequestModel: {
            userName: emailAddress,
            password: password
        }
    }, {
        params: {
            hasToken: false
        }
    }).then(res => {
        if (res.data.userNotFound === false) {
            const parkerId = res.data.spotSyncUserId!;
            setAuthToken({ accessToken: res.data.accessToken! });
            
            setAuth({ isLoggedIn: true, account: parker as any });
            
            if (redirect !== undefined) {
                setRedirect(undefined);
                nav(`${redirect}`);
            } else {
                nav("/");
            }
        }
    });
}

